import { axiosApi } from "services/api";

// Fetch all collaborations
export const fetchAllCollaborations = async (token, data, page) => {
    try {
        const response = await axiosApi.post(`/collaborations/filter?page=${page}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data; // Returning data from the response
    } catch (error) {
        throw error; // Throw the error to be caught in the action/reducer
    }
};

// Fetch pending collaborations
export const fetchMyPendingCollaborations = async (token, data, page) => {
    try {
        const response = await axiosApi.post(`/get/my-collaborations?page=${page}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data; // Return data from the response
    } catch (error) {
        throw error; // Handle error in action/reducer
    }
};

// Fetch single collaboration data
export const fetchSingleCollaborationData = async (token, data) => {
    try {
        const response = await axiosApi.post("/collaboration/get", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data; // Return data from the response
    } catch (error) {
        throw error; // Handle error in action/reducer
    }
};